module.exports = "https://qp-assets.quero.com/assets/images/credit-card-brands/elo-nobg.svg?38703536d3d4b89f8b2aa33d5beea436";